import { Dispatch } from "@reduxjs/toolkit";
import { unauthorized } from "../reducers/unauthorized";

export const catch401 = (code: any, dispatch: Dispatch) => {
    if(code === 401){
        dispatch({ type: unauthorized });
        return;
    }
}